import { Component, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CommonTabService } from './shared/services/common-tab.service';
import { DataService } from './shared/services/data.service';
import { NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RealtimeService } from './shared/services/realtime.service';
import { StorageService } from './shared/services/storage.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // For Progressbar
  loaders = this.loader.progress$.pipe(
    delay(1000),
    withLatestFrom(this.loader.progress$),
    map(v => v[1]),
  );

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    public dataService:  DataService,
    private loader: LoadingBarService, translate: TranslateService, private commonTabService: CommonTabService,
    public router: Router,
    private modalService: NgbModal, private realtimeService: RealtimeService,private storageService: StorageService,  ) {
    if (isPlatformBrowser(this.platformId)) {
      translate.setDefaultLang('en');
      translate.addLangs(['en', 'de', 'es', 'fr', 'pt', 'cn', 'ae']);
    }
    // this.getAllDropdownListData();
    this.dataService.isLoading
    window.addEventListener('beforeunload', () => {
      this.realtimeService?.disposeSMXHubConnection();
  });
  }
  async ngOnInit() {
    const accessToken = this.storageService?.retrieve('authorizationDataIdToken');
        if(accessToken  && location.pathname != '/auth/login') {
            await  this.realtimeService?.createHubConnectionForSMX();
        }
    this.closeOpenModal()
    }
    closeOpenModal(){
      this.router.events.subscribe((event: any): void => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {
           this.modalService.dismissAll()
          }
        }
      });
    }
//get all common dropdown list :( start)

//get all common dropdown list :( end)
  
}


